@if (isEditMode) {
  <div class="table-content" title="{{ cellValue }}">
    <input class="form-control edit-mode-input" [(ngModel)]="cellValue" (blur)="blurAction()" (change)="changeAction()" (focus)="focusAction()" autofocus />
  </div>
}
@if (!isEditMode) {
  <div class="table-content" title="{{ cellValue }}" (dblclick)="dbClickAction()">
    {{ cellValue }}
  </div>
}